import uiEnums from 'enums/ui';

export default {
  attachmentError: null,
  autoShowWidget: false,
  chatLastViewedAt: null,
  // deprecated, please use userComposition
  compositionDraft: '',
  compositionStage: '',
  isMinimized: true,
  isVisible: false, // displayed based on office hours or cookies
  locationHistory: [uiEnums.LOCATIONS.HOME],
  minimizedAt: null,
  proactiveGreeting: {
    message: '',
    isVisible: false,
  },
  stage: null,
  unreadMessageCount: 0,
  userComposition: {
    attachments: [],
    text: '',
  },
  suppressedByRules: false,
};
